import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useRouter } from "next/router";
import { useEffect } from "react";
import * as apiCache from "../apiCacheCalls";
import { PHead } from "../components/global/PHead/PHead";
import { useCustomerAnalytics } from "../services/hooks/useCustomerAnalytics";
import { useAppSelector } from "../services/hooks/useReduxHooks";
import { CUSTOMER_ANALYTICS_EVENT, PagesEnum } from "../utils/enums";
import env from "../utils/env.config";
import { globalTranslationFiles } from "../utils/help/localization/localization";
import { getPageLink } from "../utils/help/navigation/navigation";

function Main(props: {
  restaurantInfo: any;
  socialMediaInfo: {
    fbId: string;
    googleTagsManager: string;
    fbDomainVerificationId: string;
    tiktokId: string;
  };
}) {
  const addCustomerAnalytics = useCustomerAnalytics();
  const router = useRouter();
  const restaurantInfo = useAppSelector((state) => state.config.restaurantInfo);

  useEffect(() => {
    if (router.isReady && restaurantInfo) {
      console.log("router push 7th imp", router.query, PagesEnum.Home);
      const pageLink = getPageLink(router, PagesEnum.Home);
      router.push(pageLink.href, pageLink.as);
    }
  }, [router.isReady, restaurantInfo?.id]);

  useEffect(() => {
    addCustomerAnalytics(CUSTOMER_ANALYTICS_EVENT.ENTERED_WEBSITE, {
      qrcode: router.query.qrcode ? router.query.qrcode.toString() : undefined,
    });
  }, []);

  if (!props.restaurantInfo || !props.socialMediaInfo) {
    return null;
  }

  return (
    <PHead
      restaurantInfo={props.restaurantInfo}
      socialMediaInfo={props.socialMediaInfo}
    />
  );
}

export const getStaticProps = async (context: any) => {
  const restaurantInfo = await apiCache.fetchCall(
    `/restaurant/${env.restaurantId}`,
    env.apiV1
  );

  let socialMediaInfo;
  try {
    socialMediaInfo = await apiCache.fetchCall(
      `/restaurant/social-media/${env.restaurantId}`,
      env.apiV1
    );
  } catch (error) {
    console.log("Error fetching social media", error);
    socialMediaInfo = null;
  }

  return {
    props: {
      socialMediaInfo: socialMediaInfo || {},
      restaurantInfo,
      ...(await serverSideTranslations(context.locale, [
        ...globalTranslationFiles,
        "cart",
        "addons",
        "offers",
      ])),
    },
  };
};

Main.displayName = "Main";

export default Main;
